<template>
    <div class="main">
      <message-head type="question" title="无牌车身份确认">
        <span>使用您的微信号停车或结算</span>
      </message-head>
      <br />
      <div class="tips">点击确认后, 将会以您的微信账号ID, 作为本次停车的信息依据停车计费。若您的微信关联有月租信息, 则会被识别为月租车。</div>
      <div class="buttons">
        <van-button block type="primary" :disabled="!seq" @click="confirm">确定</van-button>
        <br />
        <van-button block type="default" @click="close">取消</van-button>
      </div>
    </div>
</template>

<script>
import { Button, Cell, CellGroup, Collapse, CollapseItem, Icon } from 'vant';
// import qs from 'query-string';
import MessageHead from '../components/MessageHead.vue';
import qs from 'query-string';
import { router } from '../router';

export default {
  components: {
    [Icon.name] : Icon,
    [Cell.name] : Cell,
    [CellGroup.name] : CellGroup,
    [Collapse.name] : Collapse,
    [CollapseItem.name] : CollapseItem,
    [Button.name] : Button,
    'message-head' : MessageHead
  },
  data() {
    return {
      seq: null,
      loading: false
    };
  },
  mounted() {
    const {s} = qs.parse(location.search);
    this.seq = s;
  },
  methods: {
    async confirm() {
      
      const orderId = await this.$http.post('/gate/recognize_by_seq', { seq: this.seq });
      if (orderId) {
        router.push('/paying?orderId='+orderId);
      } else {
        this.close();
      }
    },
    close() {
      this.$wechat.sdk(sdk => sdk.closeWindow());
    }
  }
};
</script>

<style lang="less" scoped>
  .buttons {
    padding: 10px;
    margin-top: 30px;
  }
  .tips {
    font-size: 12px;
    color: gray;
    padding: 10px;
  }
</style>